export default {"src":"/uk/_next/static/media/spot-gold.559d87ef.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};